import { useState } from 'react'
import AuthService from 'services/auth'
import cutileiApi from 'services/cutileiApi'
import { logApiError } from 'services/apiError'
import AlertDialog from 'components/AlertDialog'
import PasswordInput from 'components/Inputs/PasswordInput'
import PasswordStrengthBar from 'components/PasswordStrengthBar'
import passwordValidator from 'validators/passwordValidator'
import MainButton from 'components/Buttons/MainButton'
import { Formik } from 'formik'

import {
  Container,
  Form,
  Row,
  SubTitle,
  FormField,
  WarningText,
  ErrorContainer,
} from '../../styles'

export default function ChangeProfessionalPassword ({ professional }) {
  const [errorMessage, setErrorMessage] = useState (null)
  const [showOkDialog, setShowOkDialog] = useState (false)
  const businessId = AuthService.getBusinessId ()
  const token = AuthService.getToken ()

  const requestConfig = {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  }

  const toggleOkDialog = () => setShowOkDialog (!showOkDialog)

  return (
    <Container>
      <Formik
        validationSchema={passwordValidator}
        initialValues={{
          'password': '',
          'password_confirmation': ''
        }}
        onSubmit={async (values, { setSubmitting }) => {
          const { password } = values

          setErrorMessage (null)
          setSubmitting (true)

          try {
            await cutileiApi.put (
              `/businesses/${businessId}/professionals/${professional?.id}`,
              { password },
              requestConfig
            )

            setSubmitting (false)
            toggleOkDialog ()
          } catch (error) {
            setSubmitting (false)
            logApiError (error)
          }
        }}
      >
        {({
          values,
          errors,
          touched,
          isSubmitting,
          handleChange,
          handleBlur,
          handleSubmit
        }) => (
          <Form style={{width: 480}}>
            <SubTitle>Alterar senha</SubTitle>
            <Row>
              <FormField>
                <PasswordInput
                  placeholder='Nova senha'
                  value={values.password}
                  onChange={handleChange ('password')}
                  onBlur={handleBlur ('password')}
                />
                {touched.password && errors.password && (
                  <WarningText>{errors.password}</WarningText>
                )}
                <PasswordStrengthBar password={values.password}/>
              </FormField>
            </Row>
            <Row>
              <FormField>
                <PasswordInput
                  placeholder='Confirmar senha'
                  value={values.password_confirmation}
                  onChange={handleChange ('password_confirmation')}
                  onBlur={handleBlur ('password_confirmation')}
                />
                {touched.password_confirmation && errors.password_confirmation && (
                  <WarningText>{errors.password_confirmation}</WarningText>
                )}
              </FormField>
            </Row>
            {errorMessage && (
              <ErrorContainer>
                <p>{errorMessage}</p>
              </ErrorContainer>
            )}
            <AlertDialog
              visible={showOkDialog}
              title='Sucesso'
              message='Senha alterada!'
              confirmText='Ok'
              onConfirm={toggleOkDialog}
              onClose={toggleOkDialog}
            />
            <MainButton
              label='Alterar senha'
              onClick={handleSubmit}
              disabled={isSubmitting}
              loading={isSubmitting}
              width={140}
              style={{alignSelf: 'center'}}
            />
          </Form>
        )}
      </Formik>
    </Container>
  )
}
